import React, { useEffect, useState, memo } from "react";

import "./CredenciaisExpirando.scss";
import ModalCredenciais from "../modalCredenciais/ModalCredenciais";
import AjudaCard from "../../../../shared/components/ajudaCard/AjudaCard";

function CredenciaisExpirando({ sendRequest, clinica, auth, estilo }) {
  const [orcamentosCredenciais, setOrcamentosCredenciais] = useState([]);
  const [orcamentosAExpirar, setOrcamentosAExpirar] = useState([]);
  const [orcamentosEmAjuste, setOrcamentosEmAjuste] = useState([]);
  const [orcamentosExpirados, setOrcamentosExpirados] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fetchCredenciaisPorExpirar = async () => {
      try {
        const response = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/orcamentos/credenciaispertosdeexpirar/${clinica.clinica._id}`,
          "GET",
          null,
          { Authorization: "Bearer " + auth.token },
        );

        // Usar o status já calculado pelo backend
        const aExpirar = response.orcamentos.filter(
          (orcamento) => orcamento.status === "A EXPIRAR",
        );

        const emAjuste = response.orcamentos.filter(
          (orcamento) => orcamento.status === "EM_AJUSTE",
        );

        const expirados = response.orcamentos.filter(
          (orcamento) => orcamento.status === "EXPIRADO",
        );

        setOrcamentosCredenciais(response.orcamentos);
        setOrcamentosAExpirar(aExpirar);
        setOrcamentosEmAjuste(emAjuste);
        setOrcamentosExpirados(expirados);
      } catch (err) {
        console.error("Erro ao buscar credenciais:", err);
      }
    };

    fetchCredenciaisPorExpirar();
  }, [auth.token, clinica.clinica._id, sendRequest]);

  return (
    <>
      <div
        style={{
          display: "flex",
          height: "100%",
          justifyContent: "spance-between",
          flexDirection: "column",
        }}
      >
        <span className="box-title box-title--com-ajuda">
          Credenciais Expirando
          <AjudaCard titulo="O que conta nas credenciais a expirar">
            <p>
              <strong>Credenciais que ainda não foram enviadas</strong> à
              instituição. Só entram orçamentos com benefício (não
              particulares), já transformados e com número e data de credencial.
            </p>
            <p>
              A credencial vale <strong>180 dias</strong> a contar da data dela:
              150 de tratamento mais 30 de janela de ajuste.
            </p>
            <ul>
              <li>
                <strong>próximos de expirar</strong> — faltam 31 a 60 dias.
              </li>
              <li>
                <strong>em janela de ajuste</strong> — faltam 30 dias ou menos:
                já se está nos últimos 30 do prazo.
              </li>
              <li>
                <strong>expirados</strong> — o prazo já passou.
              </li>
            </ul>
            <p>
              Mostra a unidade em que entrou na plataforma, porque é essa que
              tem de enviar as suas credenciais. A vista das duas unidades está
              no relatório de credenciais.
            </p>
          </AjudaCard>
        </span>
        {orcamentosCredenciais && (
          <div className="credenciais__container">
            <div className="credenciais-info">
              <div className="credenciais-info__item">
                <span className="credenciais-info__item__number">
                  {orcamentosAExpirar.length}
                </span>
                <span className="medium-gray-text">próximos de expirar</span>
              </div>

              <div className="credenciais-info__item">
                <span
                  className={`credenciais-info__item__number ${
                    orcamentosEmAjuste.length > 0 &&
                    "credenciais-info__item__number--warning"
                  }`}
                >
                  {orcamentosEmAjuste.length}
                </span>
                <span className="medium-gray-text">em janela de ajuste</span>
              </div>

              <div className="credenciais-info__item">
                <span
                  className={`credenciais-info__item__number ${
                    orcamentosExpirados.length > 0 &&
                    "credenciais-info__item__number--danger"
                  }`}
                >
                  {orcamentosExpirados.length}
                </span>
                <span className="medium-gray-text">expirados</span>
              </div>
            </div>
          </div>
        )}
        <div
          className="button-more-div"
          onClick={() => {
            setOpen(true);
          }}
        >
          <span className="button-more">Mais</span>
          <span className="more-arrow"> {">"} </span>
        </div>
      </div>

      {open && (
        <ModalCredenciais
          orcamentos={orcamentosCredenciais}
          orcamentosAExpirar={orcamentosAExpirar}
          orcamentosExpirados={orcamentosExpirados}
          handleClose={() => {
            setOpen(false);
          }}
          openModal={open}
        />
      )}
    </>
  );
}

export default memo(CredenciaisExpirando);
